export const updateOnBomImportSuccess = (
  state,
  bom,
  initial_selected_board_qty,
) => {
  state.data_for_import.header = null;
  state.data_for_import.first_row = null;
  state.data_for_import.ref_des_separator = ',';
  state.data_for_import.ref_des_range_separator = '-';
  state.data_for_import.bom_parameters = [];
  state.data_for_import.workbook = [];

  state.id = bom.id;
  state.version = bom.version;
  state.board_qtys = bom.board_qtys;
  state.selected_board_qty = bom.board_qtys.includes(initial_selected_board_qty)
    ? initial_selected_board_qty
    : bom.board_qtys[0];
  state.bom_status = bom.bom_status.toUpperCase();
  state.quote_type = bom.quote_type;
  state.preferences = bom.preferences;
  state.totals = {};
  state.bom_line_items = bom.bom_line_items;
  state.bom_line_items.forEach((bli, index) => {
    state.bom_line_items[index].user_action = '';
    state.bom_line_items[index].error_message = {};
  });
};
